import axios from 'axios';

export const get = () => axios.get('/api/session');